import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const CatalogContext = createContext(null);

export const CatalogProvider = ({ children }) => {
  const [catalog, setCatalog] = useState(null);
  useEffect(() => {
    api.get("/catalog").then((r) => setCatalog(r.data)).catch(() => setCatalog({ materials: [], glass_types: [], profiles: {} }));
  }, []);
  return <CatalogContext.Provider value={catalog}>{children}</CatalogContext.Provider>;
};

export const useCatalog = () => useContext(CatalogContext);

export const useMaterial = (id) => {
  const c = useCatalog();
  return c?.materials.find((m) => m.id === id);
};
